const app = {
  state: {
    waiting: true,
    path: "",
    path_name: "",
    model: "",
  },
  mutations: {
    SET_WAITING: (state, waiting) => {
      state.waiting = waiting;
    },
    SET_PATH: (state, path) => {
      state.path = path;
    },
    SET_PATH_NAME: (state, name) => {
      state.path_name = name;
    },
    SET_MODEL: (state, name) => {
      state.model = name;
    },
  },

  actions: {
    // 设置加载中
    setWaiting({ commit }) {
      return new Promise((resolve) => {
        commit("SET_WAITING", true);
        resolve();
      });
    },
    // 设置当前路径
    setPath({ commit }, path) {
      return new Promise((resolve) => {
        commit("SET_PATH", path);
        resolve();
      });
    },
    // 设置当前路径名称
    setPathName({ commit }, name) {
      return new Promise((resolve) => {
        commit("SET_PATH_NAME", name);
        resolve();
      });
    },
    // 设置当前模型
    setModel({ commit }, name) {
      return new Promise((resolve) => {
        commit("SET_MODEL", name);
        resolve();
      });
    },
  },
};

export default app;
